<div class="c-menuModal">
  <div class="c-menuModal__bg">
    <slotcom-navigation-button
      type="close"
      rightPosition="-5"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div class="c-menuModal__container">
      <div class="c-back-button">
        @if (showBack()) {
          <slotcom-navigation-button
            type="back"
            [outline]="true"
            (click)="manageBack()">
          </slotcom-navigation-button>
        }
      </div>

      <div class="c-menuModal__title">
        <ng-container [cdkPortalOutlet]></ng-container>
      </div>

      <div class="c-modalMenu__content">
        <div class="c-modalMenu__main">
          <ng-container [cdkPortalOutlet]></ng-container>
        </div>

        <div class="c-modalMenu__footer">
          <ng-container [cdkPortalOutlet]></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Header Portal -->
<ng-template #defaultHeader>
  <span
    [innerHTML]="
      'home.nav.config.welcome' | translate: { username: user.nickName ? user.nickName : user.userName }
    "></span>
</ng-template>

<ng-template #configHeader>
  <span class="icons-sprite tiny settings"></span>
  <span
    class="section-title"
    [innerHTML]="'home.nav.config.title' | translate | uppercase"></span>
</ng-template>

<ng-template #audioHeader>
  <span class="icons-sprite tiny audio"></span>
  <span
    class="section-title"
    [innerHTML]="'home.nav.config.audio.label' | translate | uppercase"></span>
</ng-template>

<ng-template #followUsHeader>
  <span class="icons-sprite tiny like"></span>
  <span
    class="section-title"
    [innerHTML]="'home.nav.config.follow' | translate | uppercase"></span>
</ng-template>

<ng-template #aboutUsHeader>
  <span class="icons-sprite tiny info"></span>
  <span
    class="section-title"
    [innerHTML]="'home.nav.config.about-us' | translate | uppercase"></span>
</ng-template>

<!--  -->

<!-- Footer Portal -->
<ng-template #facebookFooter> </ng-template>

<ng-template #configFooter>
  <span class="text title"
    >{{ 'home.nav.config.userId' | translate
    }}<span
      class="text"
      (click)="copyIdToClipBoard(user.id)">
      {{ user.id }}
    </span></span
  >
  <span class="text title">
    {{ 'home.nav.config.version' | translate }}
    <span class="text"> {{ version }} {{ isNative ? ' | ' + nativeVersion : '' }}</span>
  </span>

  <span class="text title">
    Migrated:
    <span class="text">{{ isMigrated }}</span>
  </span>
</ng-template>

<!--  -->

<!-- Main Container Portal -->
<ng-template #main>
  <div class="c-modalMenu__main__options">
    <div class="c-option">
      @if (notifications?.pendingFriends) {
        <slotcom-badge [value]="notifications?.pendingFriends"></slotcom-badge>
      }
      <slotcom-button
        class="c-button--menu"
        (click)="goToProfile()"
        audioType="functionality">
        <span class="icons-sprite big profile"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.profile' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="changeView(configPortalContent)"
        audioType="functionality">
        <span class="icons-sprite big settings"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.title' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="goToContact()"
        audioType="functionality">
        <span class="icons-sprite big contact"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.contact' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="goToRateUs()"
        audioType="functionality">
        <span class="icons-sprite big star-shadow"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.likeUS' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="changeView(followUsPortalContent)"
        audioType="functionality">
        <span class="icons-sprite big like"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.follow' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="changeView(aboutUsPortalContent)"
        audioType="functionality">
        <span class="icons-sprite big info"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.about-us' | translate | uppercase }}</span>
    </div>
  </div>
</ng-template>

<ng-template #config>
  <div class="c-modalMenu__main__config">
    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="changeView(languageSelectorPortalContent)"
        audioType="functionality">
        <span class="icons-sprite big language"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.language' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="changeView(audioPortalContent)"
        audioType="functionality">
        <span class="icons-sprite big audio"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.audio.label' | translate | uppercase }}</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="logOut()"
        audioType="functionality">
        <span class="icons-sprite big logout"></span>
      </slotcom-button>

      <span class="icon-text">{{ 'home.nav.config.logoff' | translate | uppercase }}</span>
    </div>
  </div>
</ng-template>

<ng-template #languageSelector>
  <div class="c-modalMenu__main__languageSelector">
    @for (culture of cultures | async; track culture) {
      <div class="c-option">
        <slotcom-button
          class="c-button--menu c-button--menu--long"
          [ngClass]="{
            'c-button--menu--unSelected': cultureSelected !== culture.value
          }"
          (click)="cultureSelected = culture.value"
          audioType="functionality">
          <span class="icon-text">{{ culture.text | uppercase }}</span>
        </slotcom-button>
      </div>
    }
  </div>

  <slotcom-button
    class="c-button--sky"
    (click)="changeLang(cultureSelected)"
    audioType="functionality">
    <span class="icon-text">{{ 'home.buttons.change' | translate | uppercase }}</span>
  </slotcom-button>
</ng-template>

<ng-template #audio>
  <div
    class="c-modalMenu__main__audio"
    [formGroup]="audioForm">
    <!-- <div class="switch-container">
      <div class="switch-label">
        {{ 'home.nav.config.audio.bgm' | translate | uppercase }}
      </div>
      <div class="switch-control">
        <label
          class="switch"
          for="bgm">
          <input
            id="bgm"
            type="checkbox"
            formControlName="bgm" />
          <span class="slider round"></span>
        </label>
      </div>
    </div> -->
    <div class="switch-container">
      <div class="sound">
        <div class="switch-label">
          {{ 'home.nav.config.audio.sfx' | translate | uppercase }}
        </div>
        <div class="switch-control">
          <label
            class="switch"
            for="sfx">
            <input
              id="sfx"
              type="checkbox"
              formControlName="sfx" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #followUs>
  <div class="c-modalMenu__main__followus">
    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="goToFacebook()"
        audioType="functionality">
        <span class="icons-sprite big facebook-squared"></span>
      </slotcom-button>

      <span class="icon-text">FACEBOOK</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="goToInstagram()"
        audioType="functionality">
        <span class="icons-sprite big instagram"></span>
      </slotcom-button>

      <span class="icon-text">INSTAGRAM</span>
    </div>

    <div class="c-option">
      <slotcom-button
        class="c-button--menu"
        (click)="goToYoutube()"
        audioType="functionality">
        <span class="icons-sprite big youtube"></span>
      </slotcom-button>

      <span class="icon-text">YOUTUBE</span>
    </div>
  </div>
</ng-template>

<ng-template #aboutUs>
  <div class="c-modalMenu__main__aboutus">
    <slotcom-button
      class="c-button--menu c-button--menu--long"
      (click)="openTerms()"
      audioType="functionality">
      <span class="icon-text">{{ 'home.nav.config.terms' | translate | uppercase }}</span>
    </slotcom-button>

    <slotcom-button
      class="c-button--menu c-button--menu--long"
      (click)="openCookies()"
      audioType="functionality">
      <span class="icon-text">{{ 'home.nav.config.cookies' | translate | uppercase }}</span>
    </slotcom-button>

    <slotcom-button
      class="c-button--menu c-button--menu--long"
      (click)="openPrivacy()"
      audioType="functionality">
      <span class="icon-text">{{ 'home.nav.config.privacy' | translate | uppercase }}</span>
    </slotcom-button>
  </div>
</ng-template>
